import { useTranslations } from 'hooks/useTranslations';
import { Elabels } from '../helpers';
import { Grid, Typography } from '@mui/material';
import { StyledValueFormHeader } from '../styles';
import { StyledDocumentFormContainer } from './styles';
import { FileDropzoneContainer } from 'components/molecules/FormInputFile';
import { findInDictionary } from 'helpers/dictionary';
import { EMIMETypes } from 'constants/MIMETypes';
import { FormCheckbox } from 'components/molecules/FormCheckbox';
import { IVaryDataVariationsDocuments } from 'models/licence';
import { IDictionary } from 'models/dictionary';

interface IDocumentsForm {
  uniqueId: string;
  documents: IVaryDataVariationsDocuments[];
  documentWillUploadLetterWatch: any;
  attachmentDocumentTypeData: IDictionary[] | null;
  errors: any;
  setValue: any;
  control: any;
}

export const DocumentsForm = ({
  uniqueId,
  documents,
  documentWillUploadLetterWatch,
  attachmentDocumentTypeData,
  errors,
  setValue,
  control,
}: IDocumentsForm) => {
  const { t } = useTranslations();
  return (
    <Grid sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      {!!documents.length && (
        <>
          <Grid size={{ xs: 12 }} sx={{ mt: 2 }}>
            <StyledValueFormHeader>{t(Elabels.documents)}</StyledValueFormHeader>
          </Grid>
          <Typography variant="body2">{t(Elabels.documentSubtitle)}</Typography>
          <Grid sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {documents.map((document: any) => (
              <StyledDocumentFormContainer
                key={document.uniqueId}
                container
                columnSpacing={2.5}
                sx={{ rowGap: 1 }}
              >
                <Grid
                  size={{ xs: 12, md: 4 }}
                  sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
                >
                  <FileDropzoneContainer
                    key={`documents-${uniqueId}-${document.uniqueId}`}
                    label={
                      findInDictionary(document.typeUniqueId, attachmentDocumentTypeData) ?? ''
                    }
                    name={`documents.${document.uniqueId}`}
                    fileName={`documentsFilenames.${document.uniqueId}`}
                    required
                    multiple
                    errors={errors}
                    disabled={!!documentWillUploadLetterWatch?.[document.uniqueId]}
                    setValue={setValue}
                    disabledInputName={false}
                    allowedType={[
                      EMIMETypes.JPEG,
                      EMIMETypes.JPG,
                      EMIMETypes.PNG,
                      EMIMETypes.PDF,
                    ]}
                  />
                  <Grid sx={{ mt: 1 }}>
                    <FormCheckbox
                      key={`documentWillUploadLetter-${uniqueId}-${document.uniqueId}`}
                      name={`documentWillUploadLetter.${document.uniqueId}`}
                      label={t(Elabels.willUploadLetter)}
                      control={control}
                      errors={errors}
                      withValidation={false}
                      id="documents_form_upload-checkbox"
                    />
                  </Grid>
                </Grid>
                <Grid
                  size={{ xs: 12, md: 6 }}
                  sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}
                >
                  <Typography variant="subtitle2">
                    {t(Elabels.documentImportantNotice)}
                  </Typography>
                  <Typography variant="body2">{document?.importantNotice}</Typography>
                </Grid>
              </StyledDocumentFormContainer>
            ))}
          </Grid>
        </>
      )}
    </Grid>
  );
};
